export default {
  metaTitle: '店铺帐号',
  pageTitle: '管理店员帐号',
  secendTitle: '店铺帐号列表',
  newStaff: '新职员',
  staff: '职员',
  staffId: '职员ID',
  loginAccount: '登陆帐户',
  trueName: '真实姓名',
  password: '密码',
  status: '状态',
  active: '激活',
  locked: '锁定',
  save: '保存',
  title1: '权限配置',
  accountInfo: '帐号信息',
  staffInfo1: 'hello', // TODO 【欢迎语或打招呼语，请按当地情况设置】
  staffInfo2: 'ven',
  moduleList1: '商品',
  moduleList2: '订单',
  moduleList3: '店铺',
  moduleList4: '优惠券',
  moduleList5: '闪购(秒杀)',
  moduleList6: '用户',
  moduleList7: '运营',
  moduleList8: '售后',
  moduleList9: '清结算',
  moduleList10: '促销',
  // -------------
  name2: '仓库设置',
  name3: '添加商品',
  name4: '商品列表',
  name5: '店内分类设置',
  name6: '批量导入商品',
  name7: '商品评价',
  name8: '批量设置扩展价',
  name9: '销售订单',
  name10: '发运单',
  name11: '自发货设置',
  name12: '店铺列表',
  name13: '店铺设置',
  name15: '店铺帐号管理 ',
  name16: '开发者信息',
  name17: '优惠券类型',
  name18: '优惠券批次管理',
  name19: '优惠券管理',
  name20: '管理秒杀商品',
  name21: '报名的闪购',
  name22: 'TD(限时折扣)报名',
  name23: '我报名的TD(限时折扣)',
  name24: '对话消息',
  name25: '积分计划',
  name26: '推荐商品设置',
  name27: '申请促销活动',
  name28: '售后',
  name29: '清结算',
  name30: '参加促销活动(所有类型)',
  name31: '我的团购',
  name32: '我参与的大促',
  // ----------------
  add: '添加',
  edit: '编辑',
  column1: '职员id',
  column2: '帐号',
  column3: '真实姓名',
  column4: '状态',
  column5: '操作',
  column6: '最后登陆ip',
  column7: '最后登陆时间',
  // active: '激活的',
  // locked: '锁定的',
  permission: '权限配置',
  warning1: '请输入用户名',
  warning2: '请输入真实姓名',
  warning3: '请输入密码',
  warning4: '长度不能少于6',
  warning5: '请选择状态',
  marketScope: '市场范围',
  warning6: '请至少选择一个市场'
}
